export const PARALLAX_SPEED = 0.5;
export const INITIAL_SCALE = 1.5;
